export default {"src":"https://cdn.jetlend.ru/_next/static/media/feature-withdraw.7cc3b661.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};